var map = {
	"./Bilgi Güvenliği Politikası PT.OR.01.pdf": "./public/files/Bilgi Güvenliği Politikası PT.OR.01.pdf",
	"./ISO 27001 EN.pdf": "./public/files/ISO 27001 EN.pdf",
	"./ISO 27001 TR.pdf": "./public/files/ISO 27001 TR.pdf",
	"./PT.OR.01 Bilgi Güvenliği Politikası.pdf": "./public/files/PT.OR.01 Bilgi Güvenliği Politikası.pdf",
	"./PT.OR.12_0 Demiröen Haberlesme - Genel Aydınlatma Metni.pdf": "./public/files/PT.OR.12_0 Demiröen Haberlesme - Genel Aydınlatma Metni.pdf",
	"./PT.OR.14_0 Demirören Haberleşme-İlgili Kisi Basvuru Formu.pdf": "./public/files/PT.OR.14_0 Demirören Haberleşme-İlgili Kisi Basvuru Formu.pdf",
	"./bgys p.docx": "./public/files/bgys p.docx",
	"./genel-aydinlatma-metni.docx": "./public/files/genel-aydinlatma-metni.docx",
	"./ilgili-kisi-basvuru-formu.docx": "./public/files/ilgili-kisi-basvuru-formu.docx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/files sync recursive ^\\.\\/.*$";